import cn from 'classnames';
import { ByoAnalyticType, ByoValueType, useByoDataContext } from "@pages/Byo/ByoContext";

const TableTypeToggle = () => {
    const {
        activeValueType,
        setActiveValueType,
        activeAnalyticsType,
    } = useByoDataContext();
    // TODO Remove and use context to get functions and values

    const isDisabled = activeAnalyticsType === ByoAnalyticType.Price;
    const classListBtn1 = cn('ByoTable__header-btn', {
        'ByoTable__header-btn--active': activeValueType === ByoValueType.Pct,
        'ByoTable__header-btn--disabled': isDisabled,
    });

    const classListBtn2 = cn('ByoTable__header-btn', {
        'ByoTable__header-btn--active': activeValueType === ByoValueType.Count,
        'ByoTable__header-btn--disabled': isDisabled,
    });

    return (
        <>
            <button
                className={classListBtn1}
                onClick={() => setActiveValueType(ByoValueType.Pct)}
            >
                %
            </button>
            <button
                className={classListBtn2}
                onClick={() => setActiveValueType(ByoValueType.Count)}
            >
                #
            </button>
        </>
    );
};

export default TableTypeToggle;
